import { Helmet } from "react-helmet-async";

const SITE = "Aadvan Dry Fruits";
const DEFAULT_DESC =
  "Premium handpicked nuts, dry fruits, seeds, berries & luxury gift boxes from Sitapur. Fast local delivery, Cash on Delivery.";
const DEFAULT_IMG =
  "https://images.pexels.com/photos/38444658/pexels-photo-38444658.jpeg?auto=compress&cs=tinysrgb&w=1200";

export const Seo = ({ title, description = DEFAULT_DESC, image = DEFAULT_IMG, type = "website" }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Premium Nuts, Dry Fruits & Luxury Gifting`;
  const url = typeof window !== "undefined" ? window.location.href : "";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
